const MINIMUM_PAGE_SIZE = 8;

const PAGE_SIZE_INCREMENT = 8;

const DEFAULT_PAGE_NUMBER = 1;

export { MINIMUM_PAGE_SIZE, PAGE_SIZE_INCREMENT, DEFAULT_PAGE_NUMBER };
